import React from 'react';
import './LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: February 4, 2026</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            VlogClip AI ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy 
            explains how we collect, use, disclose, and safeguard your information when you use our Service.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          
          <h3>2.1 Personal Information</h3>
          <p>When you create an account, we collect:</p>
          <ul>
            <li>Email address</li>
            <li>Username</li>
            <li>Password (encrypted)</li>
            <li>Payment information (processed securely by Stripe)</li>
          </ul>

          <h3>2.2 Usage Information</h3>
          <p>We automatically collect:</p>
          <ul>
            <li>Device information (browser type, operating system)</li>
            <li>IP address</li>
            <li>Usage patterns and feature interactions</li>
            <li>Video processing history</li>
          </ul>

          <h3>2.3 Content Data</h3>
          <p>When you use our Service:</p>
          <ul>
            <li>YouTube URLs you submit for processing</li>
            <li>Generated clips (temporarily stored)</li>
            <li>Captions and metadata generated by our AI</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use collected information to:</p>
          <ul>
            <li>Provide, maintain, and improve our Service</li>
            <li>Process your transactions and manage subscriptions</li>
            <li>Send you service-related communications</li>
            <li>Respond to your inquiries and support requests</li>
            <li>Monitor and analyze usage patterns to improve user experience</li>
            <li>Detect and prevent fraud or abuse</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Sharing and Disclosure</h2>
          <p>We may share your information with:</p>
          
          <h3>4.1 Service Providers</h3>
          <ul>
            <li><strong>Stripe:</strong> For payment processing</li>
            <li><strong>OpenAI:</strong> For AI-powered video analysis and transcription</li>
            <li><strong>DigitalOcean:</strong> For cloud hosting services</li>
          </ul>

          <h3>4.2 Legal Requirements</h3>
          <p>We may disclose information if required by law or to protect our rights and safety.</p>

          <h3>4.3 Business Transfers</h3>
          <p>In the event of a merger or acquisition, your information may be transferred as part of business assets.</p>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>We implement appropriate security measures including:</p>
          <ul>
            <li>SSL/TLS encryption for data in transit</li>
            <li>Encrypted password storage using bcrypt</li>
            <li>Secure payment processing through Stripe</li>
            <li>Regular security audits and updates</li>
            <li>Access controls and authentication requirements</li>
          </ul>
          <p>
            While we strive to protect your information, no method of transmission over the Internet is 
            100% secure. We cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>6. Data Retention</h2>
          <p>We retain your data as follows:</p>
          <ul>
            <li><strong>Account Information:</strong> Until you delete your account</li>
            <li><strong>Generated Clips:</strong> Temporarily stored for 24-48 hours, then automatically deleted</li>
            <li><strong>Usage Logs:</strong> Retained for up to 90 days</li>
            <li><strong>Payment Records:</strong> Retained as required by law (typically 7 years)</li>
          </ul>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Correct inaccurate information</li>
            <li>Delete your account and associated data</li>
            <li>Export your data in a portable format</li>
            <li>Opt-out of marketing communications</li>
            <li>Restrict or object to certain processing activities</li>
          </ul>
          <p>To exercise these rights, contact us at vlogclipai@gmail.com.</p>
        </section>

        <section>
          <h2>8. Cookies and Tracking</h2>
          <p>We use cookies and similar technologies to:</p>
          <ul>
            <li>Maintain your session and authentication</li>
            <li>Remember your preferences (e.g., currency selection)</li>
            <li>Analyze usage patterns</li>
          </ul>
          <p>You can control cookies through your browser settings.</p>
        </section>

        <section>
          <h2>9. Children's Privacy</h2>
          <p>
            Our Service is not intended for users under 13 years of age. We do not knowingly collect 
            personal information from children under 13. If you believe we have collected such information, 
            please contact us immediately.
          </p>
        </section>

        <section>
          <h2>10. International Data Transfers</h2>
          <p>
            Your information may be transferred to and processed in countries other than your own. 
            We ensure appropriate safeguards are in place for such transfers in compliance with 
            applicable data protection laws.
          </p>
        </section>

        <section>
          <h2>11. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of significant changes 
            by email or through the Service. The "Last Updated" date at the top indicates when changes were made.
          </p>
        </section>

        <section>
          <h2>12. Contact Us</h2>
          <p>For privacy-related questions or to exercise your rights, contact us at:</p>
          <p>
            <strong>Email:</strong> vlogclipai@gmail.com<br />
            <strong>Website:</strong> https://vlogclipai.com
          </p>
        </section>

        <div className="back-link">
          <a href="/">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
